import { createContext, useContext } from "react";
//#region src/hooks/use-theme.ts
const _ThemeContext = createContext(false);
/** Used to detect nested ThemeProviders — value is true when inside a provider. */
const ThemeContext = _ThemeContext.Provider;
function useIsNestedThemeContext() {
	return useContext(_ThemeContext);
}
//#endregion
export { ThemeContext, useIsNestedThemeContext };

//# sourceMappingURL=use-theme.js.map